module.exports = __webpack_public_path__ + "static/media/c02-01-9.8fe4df0b.png";